<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div class="mb-3" :class="{'section-loading': infoLoading}"  style="overflow: hidden;max-height: 140px;">
        <div class="float-left w-75 pr-3">
          <h4 class="mb-line text-green mt-0 mb-0">特定專案推動-實支實付目標客戶 <i class="icon-attach text-orange ml-2"></i></h4>
          <div class="mb-line" style=""><span class="font-weight-bold mr-2">108/06/13 ~ 09/04</span></div>
          <div class=""><span class="font-weight-bold mr-2">33~65歲、年繳保費30萬以上。<br />具受益人確認服務機會近半年未購買儲蓄類商品。</span></div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line"><span class="font-weight-bold mr-2">維護單位</span> <span></span></div>
          <div class=""><span class="font-weight-bold mr-2">聯絡電話</span> <span></span></div>
          <div class="mb-line"><span class="font-weight-bold mr-2">聯絡分機</span> <span></span></div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
            type="button"
            style="height:43px;"
            @click="backToIndex"
            class="position-absolute btn btn-default m-0"
            v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
          ></button> 
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid pb-3" :class="{'section-loading': isLoading}">
      <div class="row">
        <real-paying-target-table
        :height="data_table_height"
        @update="updateSelection"
        @comment-modal="commentModal"
        @jump-to-customer="jumpToCustomer"
        @scheduled-access="ScheduledAccess"
        :table-data="tableData"/>
      </div>
    </div>

    <section class="container-fluid mt-3 fixed-bottom pt-3 bg-white">
      <div class="row">
        <div class="col-12">
        </div>
        <div class="col-9 col-sm-8 col-md-8">
          <div class="list inline">
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">要</span>
              <small class="text">壽險要保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">被</span>
              <small class="text">壽險主被保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">意</span>
              <small class="text">意外被保險人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">團</span>
              <small class="text">團險被保人</small>
            </div>
            <div style="margin-right: 5px;" class="item">
              <span class="tag-box">借</span>
              <small class="text">房貸借款人</small>
            </div>
          </div>
        </div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button class="btn btn-primary"
          @click="panelOpen('groupModalOpen')"
          :disabled="!selection.length">
            加入群組
          </button>
          <button class="btn btn-primary mr-0"
          @click="panelOpen('printModalOpen')"
          :disabled="!selection.length">
            列印名條
          </button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal
    :open="printModalOpen"
    :custs="selection"
    @close="panelClose('printModalOpen')"/>

    <!-- 加入群組 -->
    <group-modal
    :open="groupModalOpen"
    :custs="selection"
    @submit="submitGroup"
    @close="panelClose('groupModalOpen')"/>

    <comment-modal 
        :open="commentModalOpen"
        :comment="comment"
        @close="panelClose('commentModalOpen')"
    />

    <satisfaction-modal 
        :open="satisfactionModalOpen"
        @report="report"
        @close="panelClose('satisfactionModalOpen')"
    />

    <scheduled-access
    :open="ScheduledAccessModalOpen"
    :record="currentRecord"
    :cat-info="categoryInfo"
    @close="panelClose('ScheduledAccessModalOpen')"
    @submit="submitScheduledAccess"
    />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import PrintModal from '@/desktop/components/PrintModal'
import GroupModal from '@/desktop/components/GroupModal'
import RealPayingTargetTable from '../DataTable/RealPayingTargetTable'
import CommentModal from '../CommentModal'
import SatisfactionModal from '../SatisfactionModal'
import { getCategoryDetail , isSatisfactionSurveyFinish, queryVisitEventLog } from '@/service'
import ScheduledAccess from '../ScheduledAccess'
const tableData = [
  {"index":"17",
   "vip_level":1,
   "sex":2,
   "name":
   "我是假資料","age":"",
   "id":"L01750386I",
   "serNo":"",
   "mobile":"",
   "birthday":"1960-10-08",
   "record": "108/06/10",
   "relationship": "建議書/促約",
   "idmark":["1","N","N","N","N","6"],
   "comment":"5月12日拜訪已經提過建議書<br />5月20日再次聯絡客戶",
   "visit":"108/07/10<br />10:10"
  },{"index":"1","vip_level":0,"sex":2,"name":"還沒對接API","age":"","id":"A02627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A03810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E04790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H05634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A06915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A07627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A08810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E09790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H10634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A11915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A12627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A13810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E14790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H15634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A16915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A17627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A18810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E19790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H20634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A21915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A22627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A23810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E24790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H25634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A26915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A27627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A28810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E29790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H30634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A31915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A32627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A33810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E34790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H35634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A36915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A37627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A38810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E39790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H40634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A41915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A42627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A43810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E44790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H45634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A46915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]},{"index":"1","vip_level":0,"sex":2,"name":"張王○淑","age":"","id":"A47627695G","serNo":"","mobile":"","phone":"","birthday":"1951-01-03","address":"","idmark":["1","N","N","N","N","N"]},{"index":"2","vip_level":0,"sex":2,"name":"林王○美","age":"","id":"A48810466I","serNo":"","mobile":"","phone":"","birthday":"1943-02-05","address":"","idmark":["N","N","N","N","N","N"]},{"index":"3","vip_level":0,"sex":2,"name":"王○","age":"","id":"E49790558F","serNo":"","mobile":"","phone":"","birthday":"1935-12-23","address":"","idmark":["N","N","N","N","N","N"]},{"index":"4","vip_level":0,"sex":2,"name":"王○","age":"","id":"H50634455A","serNo":"","mobile":"","phone":"","birthday":"1960-09-13","address":"","idmark":["N","N","N","N","N","N"]},{"index":"5","vip_level":0,"sex":1,"name":"王○一","age":"","id":"A51915683D","serNo":"","mobile":"","phone":"","birthday":"1943-01-01","address":"","idmark":["N","N","N","N","N","N"]}]


const real_paying = {
  title: '特定專案推動-實支實付目標客戶',
  date: '108/06/13 ~ 09/04',
  desc: '客群1：疾病醫療日額有空間，訴求實支實付商品。<br>客群2：疾病醫療日額無訴求空間，可透過訴求壽險保額提高及實支實付商品。',
  department: '專案企劃科',
  phone: '(02)27551399',
  ext: '7136',
}

export default {
  name: 'RealPayingTarget',
  mixins: [commonMixin],
  components: {
    RealPayingTargetTable, 
    CommentModal, 
    SatisfactionModal,
    PrintModal,
    GroupModal,
    ScheduledAccess,  
  },
  props: {
    status: String,
  },
  computed: {
    
  },
  data () {  //data block layout
    return {
      currentPage: 0,
      isLoading: false,
      isLoading_btn: false,
      isBtnEnble: true,
      infoLoading: false,
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      commentModalOpen: false,
      satisfactionModalOpen: false,
      comment: '',
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      currentRecord: {},
      edit_access_index: 0,
      edit_access_name: '',
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      info: {}
    }  
  },
  methods: {
    ...mapActions([
      'setPageLock', 'updateCustID'
    ]),
    checkIsSatisfactionSurveyFinish () {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true
      isSatisfactionSurveyFinish(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        if(result.header && result.header.status == '200') {
          this.isBtnEnble = result.body.isfinish == '0' 
        } else {
          if(result.header && result.header.message) {
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: '查詢滿意度調查失敗,請重新操作'})
          }
        }
        this.isLoading_btn = false
      })
    },
    alreadyDone() {
      this.$toast.info({title: '您已回報過滿意度調查,無法重複操作'})
    },
    initRealPayingTarget() {  // 資料初始化
      this.checkIsSatisfactionSurveyFinish()
      // 取得列表資料
      this.isLoading = true

      // 取得專區資訊
      this.getTitleInfo()
    },
    getTitleInfo () { // 取得專區資訊
      this.infoLoading = true
      getCategoryDetail(this.$store.state.userInfo.id, this.$store.state.listAreaSerNo).then(result => {
        this.infoLoading = false
        if(result.header && result.header.status == '200'){
          this.categoryInfo = result.body[0]
        }
      })
    },
    updateSelection (val) {
      this.selection = val
    },
    commentModal(comment) {
        this.comment = comment
        this.panelOpen('commentModalOpen');
    },
    satisfactionModal() {
        this.panelOpen('satisfactionModalOpen');
    },
    report() {
        this.$toast.info({title:'滿意度調查 已回報'});
        this.isBtnEnble = false
        this.panelClose('satisfactionModalOpen')
    },
    jumpToCustomer(index) {  // 導頁到客戶資料
      this.updateCustID(index)
      localStorage.CustID = index
      this.$router.push({path: `/detail/CustID/tab/1`})
    },
    backToIndex() {  // 回上一頁
      this.$emit('change-status', 'STATUS_PRECISION_MARKETING_LIST');
    },

    submitGroup (group) {  // 加入群組導頁至 群組列表
      this.panelClose('groupModalOpen')
      this.$router.push({path:`/group/1`, query:{grp_id: group.grp_id, grp_name: group.grp_name}})
    },
    formatVIP (val) {  //  轉換 VIP code
      const filterData = [
        {name: '5', code: '黃金'},
        {name: '6', code: '白金'},
        {name: '7', code: '鑽石'},
      ]
      let reData = ''
      filterData.forEach(item => {
        if(val == item.code) {
          reData = item.name
        }
      })
      return reData
    },
    idmarkFormat (obj) {  //  轉換 idmark code
      if(typeof obj == 'object') {
        let data = []
        for (let index in obj) {
          if(obj[index] == '1'){
            data.push(index.substr(-1))
          }
        }
        return data
      }else{
        return ["N","N","N","N","N","N"]
      }
    },
    initRealPaying () {  // 資料初始化
      this.isLoading = true
      queryVisitEventLog(this.$store.state.userInfo.id).then(visitData => {
        if(visitData.header && visitData.header.status === '200') {
          let visitList = visitData.body.events
          getRealPaying(this.$store.state.userInfo.id).then(result => {
            this.isLoading = false
            if(result.header && result.header.status === '200') {
              this.tableData = result.body.detail.map(item => {
                let visit = {visit: {}}
                visitList.forEach(vItem => {
                  if(vItem.id == item.csidno) {
                    visit.visit = vItem
                  }
                })
                return {
                  name: item.csname || '',
                  index: item.csidno || '',
                  vip_level: this.formatVIP(item.vip),  //  轉換 VIP code
                  sex: Number(item.csidno[1]),
                  mobile: item.csmtel || '',
                  birthday: item.csbrdy || '',
                  age: item.age == undefined? '' : item.age.toString(),//客戶年齡
                  disease_medical_day_pay: item.disease_medical_day_pay,
                  disease_medical_day_limit: item.disease_medical_day_limit,
                  life_insurance_coverage: item.life_insurance_coverage,
                  idmark : this.idmarkFormat(item.idmark),   //  轉換 idmark code
                  visit_time: item.visit_time,
                  recordInfo: {},
                  ...visit, // 寫入排訪資料
                }
              })
              this.registerHanlink()  // for hard word
            }
          })
        }
      })
    },
    ScheduledAccess(index) {
      this.edit_access_index = index
      this.currentRecord = this.tableData[index]
      this.panelOpen('ScheduledAccessModalOpen')
    },
    submitScheduledAccess() {
      this.panelClose('ScheduledAccessModalOpen')
      // 資料初始化
      this.initRealPayingTarget()
    }
  },
  mounted () {
    // 資料初始化
    this.initRealPayingTarget()
    
    this.data_table_height = parseInt($(window).height()) - $('tbody').offset().top - 80
    let self = this;
    $(window).bind('orientationchange', function(event) {
      self.data_table_height = parseInt($(window).height()) - $('tbody').offset().top - 80;
    });
    $(".tab-content").css("padding-bottom","74px");
  }
}
</script>
